import { Component, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';

import { CourseDropdownComponentConfigurator } from './course-dropdown-component.configurator';
import { BaseMultiselectDropdownComponent } from '@pl/pl-lib/forms';
import { Course } from 'src/app/core/models/course';

@Component({
  selector: 'app-course-multiselect-dropdown',
  templateUrl:
    '../../../../../../node_modules/@pl/pl-lib/assets/templates/searchable-dropdown/multiselect-dropdown.component.html',
  styleUrls: [
    '../../../../plLibSetup/components/searchable-dropdown/multiselect-dropdown.component.scss'
  ]
})
export class CourseMultiselectDropdownComponent extends BaseMultiselectDropdownComponent<Course> {
  constructor(ngControl: NgControl, injector: Injector) {
    super(ngControl, injector);
    this.configurator = new CourseDropdownComponentConfigurator();
  }
}
